import React from "react";

import ReactTable from "react-table-legacy";
import _ from "lodash";

export default class CustomTableTreeDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            default_column: this.props.column ? this.props.column : [],
            column: this.props.column ? this.props.column : [],
            data: this.props.data ? this.props.data : [],
            sub_column: this.props.sub_column ? this.props.sub_column : [],
            thr_column: this.props.thr_column ? this.props.thr_column : [],
            mode: this.props.mode ? this.props.mode : 0 // 0: その他大勢 1: 調査詳細モード
        };
    }
    UNSAFE_componentWillMount() {
        let column = _.map(this.state.default_column,(data) => {
            if(data.defaultView === true){
                return data;
            }else if(data.defaultView === undefined){
                data.show = true;
                return data;
            }else{
                data.show = false;
                return data;
            }
        });
        //console.log(column);
        this.setState({ column: column})
    }    
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
            return;

        let state = Object.create(this.state);
        // state.default_column = this.props.column ? this.props.column : [];
        // state.targetted_default_column = this.props.column ? this.props.column.filter((item) => { return !item.nonTargetFilter; }) : [];
        // state.column = state.default_column;
        state.data = this.props.data ? this.props.data : [];

        this.setState(state);
    }    
    render() {
        let data = this.state.data;

        return (
            <>
                <ReactTable
                    data={data}
                    columns={this.state.column}
                    defaultPageSize={1000}
                    minRows={3}
                    filterable={false}
                    showPaginationTop={false}
                    showPaginationBottom={false}
                    sortable={false}
                    resizable={false}
                    previousText="前へ"
                    nextText="次へ"
                    rowsText="件表示"
                    loadingText='読込中…'
                    noDataText='検索してください'
                    pageText=''
                    ofText='/'
                    className="-highlight primary-pagination max-height-table"
                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                (this.props.clickRowCallback && rowInfo.index !== undefined) && this.props.clickRowCallback(this.state.data[rowInfo.index]);

                                // IMPORTANT! React-Table uses onClick internally to trigger
                                // events like expanding SubComponents and pivots.
                                // By default a custom 'onClick' handler will override this functionality.
                                // If you want to fire the original onClick handler, call the
                                // 'handleOriginal' function.
                                if (handleOriginal) {
                                    handleOriginal()
                                }
                            }
                        }
                    }}
                    //依頼
                    SubComponent={row => {
                        // a SubComponent just for the final detail
                        if (!_.get(row.original.children, "length")) {
                        return null;
                        }
                        console.log(row.original.children);
                        return (
                        <div className="ReactTableTree">
                            <ReactTable
                            className="subTable"
                            data={row.original.children || []}
                            columns={this.state.sub_column}
                            pageSize={_.get(row.original.children, "length", 0)}
                            showPagination={false}
                            />
                        </div>
                        );
                    }}
                />
            </>
        );
    }
}
